<div *ngIf="student">
  <table class="table" aria-describedby="Phones">
    <thead>
      <tr>
        <th *ngIf="!this.studentId">SyStudentId</th>
        <th *ngIf="!this.studentId">Campus</th>
        <th>Phone</th>
        <th>canText</th>
        <th>SmsDNC</th>
        <th>Preferred</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="student.phone">
        <td *ngIf="!this.studentId">{{student.syStudentId}}</td>
        <td *ngIf="!this.studentId">{{ student.campus }}</td>
        <td>{{ student.phone.phone }}
          <a (click)="checkCallCompliance(student.phone.phone)"><i class="bi bi-telephone-fill text-success"></i></a>
          <a *ngIf="!student.phone.isSmsDNC" (click)="checkSmsCompliance(student.phone.phone)"><i class="bi bi-chat-fill yellow"></i></a>
        </td>
        <td>{{ student.phone.canText }}</td>
        <td>{{ student.phone.isSmsDNC }}</td>
        <td>{{ student.phone.isPreferred }}</td>
      </tr>
    </tbody>
  </table>
</div>
